import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import LogTable from "../components/LogTable";
import Divider from "@material-ui/core/Divider";
 import Create from "../modals/CreateLog";
import axios from "axios";
import DeleteLog from "./DeleteLog";

export default function Employers(props) {
  const {
    chooseGroupId,
    filterInputs,
    setChooseGroupId,
    onHide,
    show,
  } = props;

  const [logRows, setLogRows] = useState([]);
  const [isError, setIsError] = useState(false);
  const [sortField, setSortField] = useState("");
  const [orderBy, setOrderBy] = useState(false);
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(1000);
  const [logId, setLogId] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showRemove, setShowRemove] = useState(false);


  const onLogRows = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}card/user/${chooseGroupId}`,
      
      )
      .then(({ data }) => {
        setIsLoading(false);
        setLogRows(data);
        setIsError(false);
      })
      .catch((error) => {
        setIsLoading(false);
        setIsError(true);
        setLogRows([]);
      });
  };

  useEffect(() => {
    if (show) {
      onLogRows(skip, take, sortField, orderBy);
    }
  }, [skip, take, sortField, orderBy, show]);

  const [cardId, setCardId] = useState();


  useEffect(() => {
    if (showCreate) {
      axios
      .get(`${process.env.REACT_APP_API_URL}card/inactive`)
      .then((res) => {
        const cards = res.data.map(({ id, name }) => ({
          value: id,
          label: name,
        }));
  
        setCardId(cards);
      });
    }
   
  }, [showCreate]);




  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="edit"
      centered
      className="pr-0"
    >
        <Modal.Header closeButton>
          <Modal.Title id="delete">İstifadəçi kartları</Modal.Title>
        </Modal.Header>
      <Modal.Body>
        <div className="row bg-white rounded">


          <LogTable
            logRows={logRows}
            chooseGroupId={chooseGroupId}
            setChooseGroupId={setChooseGroupId}
            setSortField={setSortField}
            setOrderByTable={setOrderBy}
            sortField={sortField}
            orderBy={orderBy}
            isLoading={isLoading}
            isError={isError}
            updateSkip={setSkip}
            updateTake={setTake}
            take={take}
            setLogId={setLogId}
            logId={logId}
            setShowCreate={setShowCreate}
            setShowRemove={setShowRemove}

          />
        </div>
      </Modal.Body>

      {showRemove && (
        <DeleteLog
          id={chooseGroupId}
          logId={logId}
          show={showRemove}
          onHide={setShowRemove}
          onLogRows={onLogRows}
          skip={skip}
          take={take}
          sortField={sortField}
          orderBy={orderBy}
        filterInputs={filterInputs}

        />
      )}

    {showCreate && (
        <Create 
        logId={logId}
        id={chooseGroupId}
        onLogRows={onLogRows}
        show={showCreate} 
        onHide={setShowCreate} 
        cardId={cardId}
          />
      )} 
    </Modal>
  );
}
